module.exports = __webpack_public_path__ + "img/google.8f268e25.png";